import { Link } from 'react-router-dom';
import TutelaLogo from '../components/icons/TutelaLogo';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { LIMES_STATE, STATE_DATE, fmtInt } from '../lib/siteState';

export default function Pilotos() {
  useDocumentMeta(
    'Pilotos | Tutela',
    'Pilotos da plataforma Tutela em avaliação com entidades públicas. Primeiro piloto: Câmara Municipal de Vila Franca de Xira, com o CIAITeX.',
    '/pilotos',
    { alternates: { 'pt-PT': '/pilotos', en: '/pilots' } },
  );
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-ink-950 text-mist">
      <div className="mx-auto max-w-3xl px-6 py-20">
        <div className="mb-6 flex items-baseline justify-between">
          <div className="font-mono text-xs uppercase tracking-[0.28em] text-ember">Pilotos</div>
          <Link
            to="/pilots"
            className="font-mono text-xs uppercase tracking-widest text-mist-faint transition-colors hover:text-mist"
          >
            EN
          </Link>
        </div>

        <h1 className="font-display text-3xl font-bold tracking-tight text-mist sm:text-4xl">
          Avaliado no terreno, com quem decide
        </h1>
        <p className="mt-6 text-lg leading-relaxed text-mist-muted">
          A Tutela cresce módulo a módulo, e cada módulo é avaliado com entidades públicas reais
          antes de qualquer promessa. Esta página regista esses pilotos, no estado em que
          verdadeiramente estão.
        </p>

        <div className="mt-14 space-y-12">
          <section className="border-t border-ink-800 pt-10">
            <h2 className="font-display text-2xl font-bold tracking-tight text-mist">
              Câmara Municipal de Vila Franca de Xira
            </h2>
            <div className="mt-4 space-y-3 leading-relaxed text-mist-muted">
              <p>
                Encontra-se em avaliação um primeiro piloto junto da Câmara Municipal de Vila Franca
                de Xira, no âmbito de um projecto de Investigação do{' '}
                <span className="text-mist">CIAITeX</span>, o Centro Municipal de Inteligência
                Artificial, Inovação e Tecnologias de Informação.
              </p>
              <p>
                O piloto avalia o módulo de{' '}
                <Link to="/limes" className="font-medium text-ember hover:brightness-110">priorização da gestão de faixas de combustível</Link> (LIMES):
                a partir do levantamento LiDAR nacional, da cartografia cadastral e de dados
                abertos, ordena, por freguesia e por parcela, as situações a verificar no terreno.
                A priorização é indicativa e apoia o planeamento do trabalho de campo; não constitui
                deteção de incumprimento nem substitui a avaliação técnica local.
              </p>
              <p>
                Estado: em avaliação piloto (2026). Em {STATE_DATE}: a consola corre em produção desde{' '}
                {LIMES_STATE.liveSince}, com {LIMES_STATE.namedAccounts} contas nomeadas do município,{' '}
                {fmtInt(LIMES_STATE.unitsEvaluated)} unidades avaliadas e {fmtInt(LIMES_STATE.verificar)} situações
                a verificar na lista. A verificação no terreno pelo município ainda não foi feita; é ela que
                mede a precisão real da lista.
              </p>
            </div>
          </section>

          <section className="border-t border-ink-800 pt-10">
            <h2 className="font-display text-2xl font-bold tracking-tight text-mist">
              O seu município
            </h2>
            <div className="mt-4 space-y-3 leading-relaxed text-mist-muted">
              <p>
                Trabalhamos com municípios e outras entidades públicas em pilotos curtos, sobre o
                território real e com dados abertos. Se faz sentido para a sua equipa, fale
                connosco:{' '}
                <a
                  href="mailto:martim@neuralforge.pt"
                  className="font-medium text-ember hover:brightness-110"
                >
                  martim@neuralforge.pt
                </a>
                .
              </p>
            </div>
          </section>
        </div>

        <div className="mt-16 flex flex-wrap items-center gap-4 border-t border-ink-800 pt-8">
          <Link
            to="/ignis"
            className="inline-flex items-center gap-2 rounded-lg bg-ember px-6 py-3 font-semibold text-ink-950 shadow-[0_0_30px_-8px_#F26A4B] transition-all duration-200 hover:brightness-110"
          >
            Conhecer o IGNIS
          </Link>
          <Link
            to="/sobre"
            className="inline-flex items-center gap-2 rounded-lg px-5 py-3 font-mono text-sm uppercase tracking-widest text-mist-muted transition-colors hover:text-mist"
          >
            Sobre a Tutela
          </Link>
          <span className="ml-auto opacity-60">
            <TutelaLogo className="h-8 w-8" variant="light" />
          </span>
        </div>
      </div>
    </div>
  );
}
